import { LoadingOutlined } from '@ant-design/icons';
import { CheckCircle } from '@emotion-icons/bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '~/components/Button';
import CloseButton from '~/components/CloseButton';
import ModalWrapper from '~/components/ModalWrapper';
import Text from '~/components/Text';
import { TEMPLATE_EXAMPLES } from '~/constants/templates';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { useDispatch, useSelector } from '~/store';
import { formSlice } from '~/store/slices/formSlice';
import {
  selectForm,
  selectInvoiceId,
  selectIsDownloadLoading,
} from '~/store/slices/formSlice/selectors';
import TemplatePreview from './TemplatePreview';
import styles from './templateselector.module.scss';

const TemplateSelector = () => {
  const isLoading = useSelector(selectIsDownloadLoading);
  const invoiceId = useSelector(selectInvoiceId);

  const formData = useSelector(selectForm);
  const isDesktop = useIsDesktop();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isSelectorVisible = searchParams.get('preview') === 'true' && invoiceId !== null;
  const { template_id: selectedTemplate } = formData;

  function setSelectedTemplate(newTemplateId: string) {
    dispatch(
      formSlice.actions.setValue({
        template_id: newTemplateId,
      }),
    );
  }

  function handleSubmit() {
    navigate(-1);
  }

  return (
    <ModalWrapper
      isVisible={isSelectorVisible}
      handleClose={handleSubmit}
      modalWidth="100%"
      modalHeight="100dvh"
      zIndex={7001}
    >
      <div className={`${styles.wrapper} full-dimensions`}>
        <div className={`${styles.headerMobile} center spread`}>
          <Text size={isDesktop ? 'md' : 'smd'} className="bold">
            Select Template
          </Text>
          <CloseButton onClose={handleSubmit} />
        </div>

        <div className={`${styles.docWrapper} v-d-flex no-scroll pos-r`}>
          {isSelectorVisible && selectedTemplate ? (
            <TemplatePreview invoiceId={invoiceId} templateId={selectedTemplate} />
          ) : (
            <div className="center">
              <p>Please select a template for preview</p>
            </div>
          )}
        </div>
        <div className={`${styles.actionsWrapper} v-d-flex`}>
          <div className={`${styles.header} center spread`}>
            <p>Select Template</p>
            <CloseButton onClose={handleSubmit} />
          </div>

          <div className={`${styles.content} full-flex has-y-scroll`}>
            {TEMPLATE_EXAMPLES.map(eachTemplate => {
              return (
                <div
                  key={eachTemplate.id}
                  className={`${styles.templateContainer} cursor-pointer pos-r center`}
                  onClick={() => {
                    setSelectedTemplate(eachTemplate.id);
                  }}
                >
                  <img src={eachTemplate.link} alt={eachTemplate.id} width={170} height={242} />
                  {selectedTemplate === eachTemplate.id && (
                    <div className={`${styles.selectedTemplate} pos-a v-center`}>
                      <CheckCircle size={36} color="var(--white)" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className={styles.footer}>
            <div className="full-width spread">
              <Button
                onClick={handleSubmit}
                data-trigger-id="generate-biodata-trigger-id"
                data-template-id={selectedTemplate}
                disabled={selectedTemplate === null || isLoading}
                size={isDesktop ? 'md' : 'sm'}
                className="full-width"
              >
                {isLoading ? <LoadingOutlined /> : 'Done'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default TemplateSelector;
